module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zigbee-scan"
  }, [_c('div', {
    staticClass: "radar-box"
  }, [_c('radar')], 1), _vm._v(" "), _c('p', {
    staticClass: "text-align-center font-size-m"
  }, [_vm._v("正在搜索中，请稍后...")]), _vm._v(" "), _c('div', {
    staticClass: "next-btn2"
  }, [_c('button', {
    staticClass: "btn-square-primary",
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e1cf2ef"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/zigbee/Scan.vue
// module id = 894
// module chunks = 1